import { UserReference } from '@/types/activity'

export type StoredLoginUser = {
  id?: string | number
  [key: string]: any
}

export const getStoredLoginUser = (): StoredLoginUser | null => {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null')
  } catch {
    return null
  }
}

export const getStoredLoginUserId = () => getStoredLoginUser()?.id

export const getCurrentUserId = (selectedUser?: UserReference) => {
  return selectedUser?.id ?? getStoredLoginUserId()
}

export const shouldUpdateEmailExclusionList = (
  selectedUser?: UserReference
) => {
  if (selectedUser?.id == null) return false
  const storedUserId = getStoredLoginUserId()
  return (
    storedUserId != null && Number(selectedUser.id) === Number(storedUserId)
  )
}
